import { useEffect, useState } from 'react';

import {
    Typography,
} from "@mui/material";

import { IconChevronLeft, IconCircleCheckFilled } from '@tabler/icons-react';

import {
    CheckoutCardContainer,
    CheckoutContainer,
    ItemsContainer,
    SummaryContainer,
    OrderSummaryText,
    OrderHeaderContainer,
    SummaryItemsContainer,
    LicenseContainer,
    ImageContainer,
    GrandTotalContainer,
} from '../../../Styles/Billings/checkoutStyles';

import { useBillingHook } from '../../../Hooks/Billings/billingHooks';

import { LicenseBuy, LicenseDetailsBuy } from '../../../Models/License/License';
import { CheckoutData } from '../../../Models/Billing/Billing';
import { CheckoutInterface } from '../../../Models/Common/CustomViewsInterfaces';

import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';
import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import GlobalFunctionHelper from '../../../Utilities/Helpers/GlobalFunctionHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { CurrencyEnum } from '../../../Utilities/Enums/CurrencyEnums';
import { BuyLicenseField, LicenseDetailsBuyField, InvoiceField, CheckoutDataField } from '../../../Utilities/Enums/ParametersEnum';
import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { ValidityType, ValidityTypeEnum } from '../../../Utilities/Enums/ValidityTypeEnums';

import { AssetImages } from '../../../Constants/Assets';

import CustomButton from '../../../CustomViews/Elements/CustomButton';
import CustomDetailsCard from '../../../CustomViews/Pages/CustomDetailsCard/CustomDetailsCard';
import CustomStepper from '../../../CustomViews/Elements/CustomStepper/CustomStepper';

import BillingInfo from './BillingInfo';
import PaymentInfo from './PaymentInfo';
import Finish from './Finish';

export default function Checkout(props: CheckoutInterface) {
    let isDarkMode = LocalStorageHelper.isDarkMode();
    let {
        isFromBilling,
        checkoutData,
        formData,
        onClickBackBtn,
    } = props;
    let currencyCode = (checkoutData?.[CheckoutDataField.CURRENCY_CODE] ?? CurrencyEnum.PHP) != CurrencyEnum.MYR ? (checkoutData?.[CheckoutDataField.CURRENCY_CODE] ?? CurrencyEnum.PHP) : "RM";

    //Use States
    let [selectedStep, setselectedStep]: any = useState<any>();
    let [fData, setfData] = useState<LicenseBuy>({ ...new LicenseBuy() });
    let [checkoutFormData, setcheckoutFormData] = useState<CheckoutData>({ ...new CheckoutData(), ...checkoutData });
    let [stripeKey, setstripeKey]: any = useState();
    let [invoiceId, setinvoiceId]: any = useState();
    let [invoicePublicId, setinvoicePublicId]: any = useState();
    let [licensePublicId, setlicensePublicId]: any = useState();
    let [licenseKey, setlicenseKey]: any = useState();
    const [queryStr, setQueryStr] = useState({
        pageSize: 10,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.BILLINGS, queryStr];
    const { DropdownData, dropdownFetchStatus, stripeSetupIntent } = useBillingHook(q_queryKey, queryStr, false);

    //Variables
    const checkoutProps = {
        checkoutFormData: checkoutFormData,
        setcheckoutFormData: setcheckoutFormData,
        formData: fData,
        setformData: setfData,
        selectedStep: selectedStep,
        setselectedStep: setselectedStep,
        stripeKey: stripeKey,
        invoiceId: invoiceId,
        setinvoiceId: setinvoiceId,
        licenseKey: licenseKey,
        setlicenseKey: setlicenseKey,
        isFromBilling: isFromBilling,
        invoicePublicId: invoicePublicId,
        setinvoicePublicId: setinvoicePublicId,
        licensePublicId: licensePublicId,
        setlicensePublicId: setlicensePublicId,
        isSuccessPayment: props.isSuccessPayment,
        setisSuccessPayment: props.setisSuccessPayment,
        onClickBackBtn: onClickBackBtn,
    };

    //Event Handlers
    const initializeCheckoutData = async() => {
        let getSetupIntentResponse = await stripeSetupIntent();

        setstripeKey(getSetupIntentResponse?.data?.data ?? "");

        if(formData) {
            setfData({
                ...formData,
                [BuyLicenseField.TRANSACTION_KEY]: (formData?.[BuyLicenseField.TRANSACTION_KEY] != null && formData?.[BuyLicenseField.TRANSACTION_KEY] != "" ? formData?.[BuyLicenseField.TRANSACTION_KEY] : GlobalFunctionHelper.getUUID()),
                // [BuyLicenseField.TRANSACTION_KEY]: (formData?.[BuyLicenseField.TRANSACTION_KEY] != null && formData?.[BuyLicenseField.TRANSACTION_KEY] != "" ? formData?.[BuyLicenseField.TRANSACTION_KEY] : ("failedtesting" + GlobalFunctionHelper.getUUID())), //Testing purposes only
            });
        }
    }

    useEffect(() => {
        if(!dropdownFetchStatus) {
            setselectedStep(DropdownData?.[CachingEnum.CHECKOUT_STEP_LIST][0]);
        }
    }, [DropdownData]);

    useEffect(() => {
        initializeCheckoutData();
    }, []);

    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Back'
                startIcon={<IconChevronLeft />}
                onClick={(e: any) => {
                    if(onClickBackBtn) {
                        onClickBackBtn();
                    }
                }} />
        </>
    }

    const renderItems = () => {
        return <ItemsContainer sx={{borderColor: 'customBorder.main'}}>
            <CustomStepper
                disableStepperOnClick={true}
                stepperItems={DropdownData[CachingEnum.CHECKOUT_STEP_LIST] ?? []}
                selectedStep={selectedStep}
                onClickStep={(e: any) => {
                    setselectedStep(e);
                }} />

            {selectedStep?.id == 1 && renderBillingInfo()}
            {selectedStep?.id == 2 && renderPaymentInfo()}
            {selectedStep?.id == 3 && renderFinish()}
        </ItemsContainer>
    }

    const renderBillingInfo = () => {
        return <BillingInfo {...checkoutProps} />
    }

    const renderPaymentInfo = () => {
        return <PaymentInfo {...checkoutProps} />
    }

    const renderFinish = () => {
        return <Finish {...checkoutProps} />
    }

    const renderSummary = () => {
        let modulesCount = checkoutData?.[CheckoutDataField.MODULES]?.length ?? 0;

        return <SummaryContainer sx={{borderColor: 'customBorder.main'}}>
            <OrderSummaryText sx={{borderColor: 'customBorder.main', color: 'primaryText'}}>Order Summary</OrderSummaryText>
            <OrderHeaderContainer sx={{borderColor: 'customBorder.main', backgroundColor: 'customBackground.main'}}>
                <Typography className="productInfoText">Product Info</Typography>
                <Typography className="priceText">Price</Typography>
            </OrderHeaderContainer>
            <SummaryItemsContainer sx={{borderColor: 'customBorder.main'}}>
                <LicenseContainer>
                    <ImageContainer sx={{borderColor: 'customBorder.main', backgroundColor: 'customBackground.main'}}>
                        <img src={AssetImages.BUY_LICENSE_IMG} />
                    </ImageContainer>

                    <div className="itemsContent">
                        <Typography className="licenseKeyText">License Key</Typography>

                        {checkoutData?.[CheckoutDataField.VALIDITY] ? <Typography className="otherDetails">
                            <IconCircleCheckFilled />
                            {checkoutData?.[CheckoutDataField.VALIDITY]} {(ValidityType?.[checkoutData?.[CheckoutDataField.VALIDITY_TYPE] ?? ValidityTypeEnum.MONTH]?.title ?? "Month")}(s) validity
                        </Typography> : ""}

                        {modulesCount > 0 ? <Typography className="otherDetails">
                            <IconCircleCheckFilled />
                            {modulesCount} Module(s)
                        </Typography> : ""}

                        {checkoutData?.[CheckoutDataField.USER_CAPACITY] ? <Typography className="otherDetails">
                            <IconCircleCheckFilled />
                            {checkoutData?.[CheckoutDataField.USER_CAPACITY]} Employee(s)
                        </Typography> : ""}
                        {checkoutData?.[CheckoutDataField.STORAGE_CAPACITY] ? <Typography className="otherDetails">
                            <IconCircleCheckFilled />
                            {checkoutData?.[CheckoutDataField.STORAGE_CAPACITY]} GB storage
                        </Typography> : ""}
                    </div>
                </LicenseContainer>
                <Typography className="amountValue">
                    {currencyCode}{GlobalFunctionHelper.amountFormatter(checkoutData?.[CheckoutDataField.SUB_TOTAL] ?? 0, 2)}
                </Typography>

                <Typography className="amountTitle">Sub Total:</Typography>
                <Typography className="amountValue">{currencyCode}{GlobalFunctionHelper.amountFormatter(checkoutData?.[CheckoutDataField.SUB_TOTAL] ?? 0, 2)}</Typography>

                <Typography className="amountTitle">Discount:</Typography>
                <Typography className="amountValue">- {currencyCode}{GlobalFunctionHelper.amountFormatter(checkoutData?.[CheckoutDataField.DISCOUNT_AMOUNT] ?? 0, 2)}</Typography>

                <Typography className="amountTitle">Tax (8%):</Typography>
                <Typography className="amountValue">{currencyCode}{GlobalFunctionHelper.amountFormatter(checkoutData?.[CheckoutDataField.TAX_AMOUNT] ?? 0, 2)}</Typography>

                <Typography className="amountTitle">Grand Total (Before Rounding):</Typography>
                <Typography className="amountValue">{currencyCode}{GlobalFunctionHelper.amountFormatter(checkoutData?.[CheckoutDataField.TOTAL_BEFORE_ADJUSTMENT] ?? 0, 2)}</Typography>

                <Typography className="amountTitle">Rounding Adjust:</Typography>
                <Typography className="amountValue">{currencyCode}{GlobalFunctionHelper.amountFormatter(checkoutData?.[CheckoutDataField.ROUND_ADJUSTMENT] ?? 0, 2)}</Typography>
            </SummaryItemsContainer>
            <GrandTotalContainer sx={{backgroundColor: 'customBackground.main'}}>
                <Typography className="grandTotalText">Grand Total (After Rounding):</Typography>
                <Typography className="grandTotalValue">{currencyCode}{GlobalFunctionHelper.amountFormatter(checkoutData?.[CheckoutDataField.TOTAL_AFTER_ADJUSTMENT] ?? 0, 2)}</Typography>
            </GrandTotalContainer>
        </SummaryContainer>
    }

    return <CheckoutCardContainer>
        <CustomDetailsCard
        title={"Checkout"}
        actionButtons={renderActionButtons()} >
            <CheckoutContainer>
                {renderItems()}
                {renderSummary()}
            </CheckoutContainer>
        </CustomDetailsCard>
    </CheckoutCardContainer>
}
